module.exports = __webpack_public_path__ + "static/media/recesses-built-in-parts.1b4c8b05.svg";